module.exports = __webpack_public_path__ + "img/sr_latin.8fca5b63.png";